import React from 'react';
import userStroyImage1 from '../../../assets/img/feed-imgs/center/story/story-user1.png'
import userStoryImage2 from '../../../assets/img/feed-imgs/center/story/story-user2.png';
import userStoryImage3 from '../../../assets/img/feed-imgs/center/story/story-user3.png';
import userStoryImage4 from '../../../assets/img/feed-imgs/center/story/story-user4.png';
import userStoryImage5 from '../../../assets/img/feed-imgs/center/story/story-user5.png';
import userStoryImage6 from '../../../assets/img/feed-imgs/center/story/story-user6.png';
import userStoryImage7 from '../../../assets/img/feed-imgs/center/story/story-user4.png';
import userStoryImage8 from '../../../assets/img/feed-imgs/center/story/story-user2.png';
import userStoryImage9 from '../../../assets/img/feed-imgs/center/story/story-user1.png';
import rightArrow from '../../../assets/img/feed-imgs/center/story/arrow-right.svg';
import plusIcon from '../../../assets/img/feed-imgs/center/story/plus.svg';
import './ShowStory.css'

const ShowStory = () => {

    const storySection = [
       {
           userName : "Lilly N",
           userImage: userStoryImage2
       },
       {
           userName : "A Robben",
           userImage: userStoryImage3
       },
       {
           userName : "Serena Nadal",
           userImage: userStoryImage4
       },
       {
           userName : "Richa Luis",
           userImage: userStoryImage5
       },
       {
           userName : "Sam DaSilva",
           userImage: userStoryImage6
       },
       {
           userName : "Lilly N",
           userImage: userStoryImage7
       },
       {
           userName : "A Robben",
           userImage: userStoryImage8
       },
       {
           userName : "Serena Nadal",
           userImage: userStoryImage9
       }
    ]
    return (
        <div className="row mb-5">
            <div className="col-10 col-lg-11 pe-0 ">
                <div className="d-flex gap-2 story-div-show">
                    <div className="col-3 col-lg-2 text-center">
                            <div className="w-100-h-100" style={{zIndex: "999",width:" 100%"}}>
                                <div className='story-image-div'>
                                    <img className="w-100 " src={userStroyImage1} alt="" />
                                    <div className='story-overlay'><img src={plusIcon} alt="" className='story-image-innerdiv cursor-pointer'/></div>                       
                                </div>
                            </div>
                               
                            <div>
                        </div>
                        <h1 style={{fontSize: "16px",fontFamily: "Roboto, sans-serif",fontWeight: "400", color: "#5B9095"}} className="mt-2">Your Story&nbsp;</h1>
                        
                    </div>
                    {/* User Story Show here */}
                   {
                       storySection.map( (items, index ) => <div className="col-3 col-lg-2 text-center" key={index}>
                            <img className="mb-2 w-100 story-image-design" src={items.userImage} alt="" />
                            <h1 className="stry-un">{items.userName}</h1>
                        </div>
                    )
                   }
                   
                </div>
            </div>
            <div className="story-icon-border col-lg-1 col-2">
                <div className="story-border-fill position-absolute top-50 start-50 translate-middle"></div>
                <a href="#">
                    <div className="position-absolute top-50 start-50 translate-middle">
                        <img src={rightArrow} alt="" />
                    </div>
                </a>
            </div>
        </div>
    );
};

export default ShowStory;